// src/App.js
import "./App.css";
import "@fontsource/inter"; // Defaults to weight 400
import React, { useContext, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Login from "./components/Login/Login";
// import PasswordReset from "./components/PasswordReset/PasswordReset";
import Register from "./components/Register/Register";
import Addons from "./components/Addons/MainAddons";
import Bookings from "./components/Bookings/Bookings";
import Organizers from "./components/Organizers/Organizers";
import AddOrganizerForm from "./components/Organizers/AddOrganizerForm";
import EditOrganizerForm from "./components/Organizers/EditOrganizerForm";
import OrganizerSuccessPage from "./components/Organizers/OrganizerSuccessPage";
import BookingDetails from "./components/Bookings/BookingDetails";
import MainLayout from "./components/MainLayout/MainLayout";
import Profile from "./Pages/Profile";
import AddVenue from "./Pages/AddVenue/AddVenue";
import Reviews from "./Pages/Reviews";
import Dashboard from "./components/Dashboard/Dashboard";
import AuthContext, { AuthProvider } from "./contexts/AuthProvider";
import Loader from "./components/Loader";
import NotFound from "./Pages/NotFound";
import VenueOwnerChatSystem from "./Pages/chat/chat";
import Venue from "./Pages/Venue";
import ConsentBanner from "./components/ConsentBanner";
import KlaviyoTracker from "./components/KlaviyoTracker";

// New components for sidebar selections
const Host = () => <div>Host Content</div>;
const Venues = () => <AddVenue />;

function App() {
  // Track current language (default en)
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "en"
  );

  // Update document direction whenever language changes
  useEffect(() => {
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
  }, [language]);

  // Listen for language changes in other tabs/windows
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "language") {
        setLanguage(event.newValue || "en");
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  return (
    <AuthProvider>
      <Router>
        <ConsentBanner />
        <KlaviyoTracker accountType="Venue" />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<AuthRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected (layout) Routes */}
          <Route path="/" element={<MainLayout language={language} setLanguage={setLanguage} />}>
            <Route path="/addons" element={<Addons />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/host" element={<Host />} />
            <Route path="/venues" element={<Venues />} />
            <Route path="/venues/:venue_id" element={<Venue />} />
            <Route path="/bookings" element={<Bookings />} />
            <Route path="/organizers" element={<Organizers />} />
            <Route path="/organizers/add" element={<AddOrganizerForm />} />
            <Route path="/organizers/edit/:id" element={<EditOrganizerForm />} />
            <Route path="/organizers/success" element={<OrganizerSuccessPage />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/settings" element={<Profile />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/messages" element={<VenueOwnerChatSystem />} />
            <Route
              path="/booking-details/:booking_id"
              element={<BookingDetails />}
            />
          </Route>

          {/* Catch-all */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

const AuthRedirect = () => {
  const { isAuthenticated, isLoading } = useContext(AuthContext);
  if (isLoading) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );
  }
  return isAuthenticated ? (
    <Navigate to="/dashboard" replace />
  ) : (
    <Navigate to="/login" replace />
  );
};

export default App;
